import { createStore } from "vuex";

import apiClient from "@/api/index";
import { PROJECT_PREFIX } from "@/constants/projects"
import { getCachedProfile, cacheProfile } from "@/utils/profileCache"

import { loginModule } from "@/store/loginModule";
import { homeModule } from "@/store/homeModule";
import { tasksModule } from "@/store/tasksModule";
import { calendarModule } from "@/store/schedule/calendarModule";
import { dayModule } from "@/store/schedule/dayModule";
import { TimeManagementModule } from "@/store/schedule/TimeManagementModule";
import { shiftPlaningModule } from "@/store/schedule/shiftPlaningModule";
import { chartsModule } from "@/store/chartsModule";
import { profileModule } from "@/store/profileModule";
import { ordersProductsModule } from "@/store/purchases/orders/ordersProductsModule";
import { ordersListModule } from "@/store/purchases/orders/ordersListModule";
import { mediaModule } from "@/store/mediaModule";
import { learningModule } from "@/store/learningModule";
import { projectsModule } from "@/store/development/projectsModule";
import { estimatesModule } from "@/store/development/estimatesModule";
import { invoiceModule } from "@/store/invoiceModule";
import { profitsModule } from "@/store/profitsModule";
import { feedbackNPSModule } from "@/store/feedback/feedbackNPSModule";
import { feedbackHashtagsModule } from "@/store/feedback/feedbackHashtagsModule";
import { feedbackAllReviewsModule } from "@/store/feedback/feedbackAllReviewsModule";
import { productsModule } from "@/store/nomenclature/productsModule";
import { fastSetsModule } from "@/store/nomenclature/fastSetsModule";
import { gameModule } from "@/store/games/gameModule";
import { documentsRegistryModule } from "@/store/documentsRegistryModule";
import { notificationsModule } from "@/store/notificationsModule";
import { сorporateOrdersListModule } from "@/store/сorporateOrders/сorporateOrdersListModule";
import { сorporateBanketsModule } from "@/store/сorporateOrders/сorporateBanketsModule";
import { сorporateOrdersProductsModule } from "@/store/сorporateOrders/сorporateOrdersProductsModule";
import { suppliersModule } from "@/store/purchases/suppliersModule";
import { productionPricesModule } from "@/store/purchases/productionPricesModule";
import { suppliersServiceLevelModule } from "@/store/purchases/suppliersServiceLevelModule";
import { feedbackGolosMetricsModule } from "@/store/feedback/feedbackGolosMetricsModule";
import { feedbackEditModule } from "@/store/feedback/feedbackEditModule";
import { screenSaversModule } from "@/store/nomenclature/screenSaversModule"
import { newsModule } from "@/store/newsModule"

import { reportsModules } from "@/store/reportsModules";
import { loyaltyModules } from "@/store/loyaltyModules";

export default createStore({
    modules: {
        login: loginModule,
        home: homeModule,
        tasks: tasksModule,
        calendar: calendarModule,
        day: dayModule,
        timeManagement: TimeManagementModule,
        shiftPlaning: shiftPlaningModule,
        charts: chartsModule,
        profile: profileModule,
        ordersProducts: ordersProductsModule,
        ordersList: ordersListModule,
        productionPrices: productionPricesModule,
        suppliersServiceLevel: suppliersServiceLevelModule,
        media: mediaModule,
        learning: learningModule,
        projects: projectsModule,
        estimates: estimatesModule,
        invoice: invoiceModule,
        profits: profitsModule,
        feedbackNPS: feedbackNPSModule,
        feedbackHashtags: feedbackHashtagsModule,
        feedbackAllReviews: feedbackAllReviewsModule,
        products: productsModule,
        fastSets: fastSetsModule,
        game: gameModule,
        documentsRegistry: documentsRegistryModule,
        notifications: notificationsModule,
        сorporateOrdersList: сorporateOrdersListModule,
        сorporateBankets: сorporateBanketsModule,
        сorporateOrdersProducts: сorporateOrdersProductsModule,
        suppliers: suppliersModule,
        feedbackGolosMetrics: feedbackGolosMetricsModule,
        feedbackEdit: feedbackEditModule,
        screenSavers: screenSaversModule,
        news: newsModule,
        ...reportsModules,
        ...loyaltyModules,
    },

    state: {
        newYearStatus: false,
        token: localStorage.getItem("token"),
        userData: null,
        username: "",
        first_name: "",
        points_of_sale: null,
        tcoins: 0,
        isLoading: false,
        mobileSidebar: false,
        user_permissions: null,
        // current_shop: null,

        sidebarItems: [
            {
                title: "Dashboard",
                name: "home",
                path: "/",
                visible: false,
                active: false,
                dropdown: false,
                access_required: false,
                icon: "home.svg",
                items: null,
            },
            {
                title: "Планы",
                name: "sales",
                path: null,
                visible: false,
                active: false,
                dropdown: true,
                access_required: true,
                icon: "sales.svg",
                items: [
                    {
                        title: "Внесение планов",
                        name: "edit_sales",
                        path: "/sales/edit_sales",
                        visible: false,
                        access_required: true,
                    },
                    {
                        title: "Отчет по выполнению плана",
                        name: "view_sales",
                        path: "/sales/view_sales",
                        visible: false,
                        access_required: true,
                    },
                    {
                        title: "Отчет по выполнению плана Татара",
                        name: "view_sales_tatar",
                        path: "/sales/view_sales_tatar",
                        visible: false,
                        access_required: true,
                    },
                ],
            },
            {
                title: "Лояльность",
                name: "loyalty",
                path: null,
                visible: false,
                active: false,
                dropdown: true,
                access_required: true,
                icon: "loyalty.svg",
                items: [
                    {
                        title: "Дашборд",
                        name: "loyalty_dashboard",
                        path: "/loyalty/dashboard",
                        visible: false,
                        access_required: true,
                    },
                    {
                        title: "Сегментация",
                        name: "loyalty_segmentation",
                        path: "/loyalty/segmentation",
                        visible: false,
                        access_required: true,
                    },
                    {
                        title: "RFM-анализ",
                        name: "loyalty_rfm",
                        path: "/loyalty/rfm",
                        visible: false,
                        access_required: true,
                    },
                    {
                        title: "Отчет по гостям",
                        name: "loyalty_marketing_guests",
                        path: "/loyalty/marketing_guests",
                        visible: false,
                        access_required: true,
                    },
                    {
                        title: "Отчет о лояльности",
                        name: "loyalty_marketing_loyalty",
                        path: "/loyalty/marketing_loyalty",
                        visible: false,
                        access_required: true,
                    },
                    {
                        title: "Любимые блюда приложения",
                        name: "loyalty_favourite_products",
                        path: "/loyalty/favourite_products",
                        visible: false,
                        access_required: true,
                    },
                    {
                        title: "Промокоды",
                        name: "loyalty_marketing_promocodes",
                        path: "/loyalty/marketing_promocodes",
                        visible: false,
                        access_required: true,
                    },
                    {
                        title: "Сертификаты",
                        name: "loyalty_certificates",
                        path: "/loyalty/certificates",
                        visible: false,
                        access_required: true,
                    },
                    {
                        title: "Последние заказы",
                        name: "loyalty_marketing_last_orders",
                        path: "/loyalty/marketing_last_orders",
                        visible: false,
                        access_required: true,
                    },
                    {
                        title: "Отчет по апсейлам",
                        name: "loyalty_fast_sets",
                        path: "/loyalty/fast_sets",
                        visible: false,
                        access_required: true,
                    },
                    {
                        title: "Отчёт по рекомендациям товаров",
                        name: "loyalty_recommendations",
                        path: "/loyalty/recommendations",
                        visible: false,
                        access_required: true,
                    },
                    {
                        title: "Аналитика лояльности",
                        name: "loyalty_analytics",
                        path: "/loyalty/loyalty_analytics",
                        visible: false,
                        access_required: true,
                    },
                    {
                        title: "Источники регистраций",
                        name: "loyalty_registration",
                        path: "/loyalty/loyalty_registration",
                        visible: false,
                        access_required: true,
                    },
                ],
            },
            {
                title: "Расписание",
                name: "schedule",
                path: null,
                visible: false,
                active: false,
                dropdown: true,
                access_required: true,
                icon: "schedule.svg",
                items: [
                    {
                        title: "Календарь",
                        name: "schedule_calendar",
                        path: "/schedule/calendar",
                        visible: false,
                        access_required: true,
                    },
                    {
                        title: "Список смен",
                        name: "schedule_shifts",
                        path: "/schedule/shifts",
                        visible: false,
                        access_required: true,
                    },
                    {
                        title: "Временные возможности",
                        name: "schedule_time_management",
                        path: "/schedule/time_management",
                        visible: false,
                        access_required: true,
                    },
                    {
                        title: "Планирование смен",
                        name: "shift_planing",
                        path: "/schedule/shift_planing",
                        visible: false,
                        access_required: true,
                    },
                ],
            },
            {
                title: "Контент",
                name: "nomenclature",
                path: null,
                visible: false,
                active: false,
                dropdown: true,
                access_required: true,
                icon: "nomenclature.svg",
                items: [
                    {
                        title: "Товары",
                        name: "products",
                        path: "/nomenclature/products",
                        visible: true,
                        access_required: false,
                    },
                    {
                        title: "Ассортиментная матрица",
                        name: "assortment",
                        group: "assortment_view",
                        path: "/nomenclature/assortment",
                        visible: false,
                        access_required: true,
                    },
                    {
                        title: "Быстрые наборы",
                        name: "fast_sets",
                        path: "/nomenclature/fast-sets",
                        visible: true,
                        access_required: false,
                    },
                    {
                        title: "Медиа экраны",
                        name: "screen_savers",
                        path: "/nomenclature/screen-savers",
                        visible: false,
                        access_required: false,
                    },
                ]
            },
            {
                title: "Закупки",
                name: "orders",
                path: null,
                visible: false,
                active: false,
                dropdown: true,
                access_required: true,
                icon: "orders.svg",
                items: [
                    {
                        title: "Внутренние заказы",
                        name: "orders_products",
                        path: "/orders/products",
                        visible: false,
                        active: false,
                        group: ['orders'],
                        access_required: true,
                    },
                    {
                        title: "Реестр поставщиков",
                        name: "suppliers",
                        path: "/suppliers",
                        visible: false,
                        active: false,
                        access_required: true,
                    },
                    {
                        title: "Отслеживание цен закупа",
                        name: "production_prices",
                        path: "/orders/production_prices",
                        group: ['orders'],
                        visible: false,
                        active: false,
                        access_required: true,
                    },
                    {
                        title: "Уровень сервиса поставщиков",
                        name: "suppliers_service_level",
                        path: "/orders/suppliers_service_level",
                        group: ['orders'],
                        visible: false,
                        active: false,
                        access_required: true,
                    },
                ]
            },
            {
                title: "Финансы",
                name: "finance",
                path: null,
                visible: false,
                active: false,
                dropdown: true,
                access_required: true,
                icon: "finance.svg",
                items: [
                    {
                        title: "ДДС",
                        name: "finance_dds",
                        path: "/finance/dds",
                        visible: false,
                        access_required: true,
                    },
                    {
                        title: "Сводный ДДС",
                        name: "aggregate_dds",
                        group: ['finance_dds'],
                        path: "/finance/aggregate_dds",
                        visible: false,
                        access_required: true,
                    },
                    {
                        title: "Фудкост",
                        name: "finance_foodcost",
                        path: "/finance/foodcost",
                        visible: false,
                        access_required: true,
                    },
                    {
                        title: "Расчет суммы закупа",
                        name: "purchase_calculation",
                        path: "/finance/purchase_calculation",
                        visible: false,
                        access_required: true,
                    },
                ],
            },
            {
                title: "Отчеты",
                name: "reports",
                path: null,
                visible: false,
                active: false,
                dropdown: true,
                access_required: true,
                icon: "reports.svg",
                items: [
                    {
                        title: "Обучение",
                        name: "reports_study",
                        path: "/reports/study",
                        visible: false,
                        access_required: true,
                    },
                    {
                        title: "Обучение-2",
                        name: "reports_study_2",
                        group: "reports_study",
                        path: "/reports/study-2",
                        visible: false,
                        access_required: true,
                    },
                    {
                        title: "Обучение Новый",
                        name: "reports_study_new",
                        group: "reports_study",
                        path: "/reports/study-new",
                        visible: false,
                        access_required: true,
                    },
                    {
                        title: "Собери кыстыбургер",
                        name: "reports_game_progress",
                        path: "/reports/game_progress",
                        visible: false,
                        access_required: true,
                    },
                    {
                        title: "Пульс компании",
                        name: "reports_charts",
                        path: "/reports/charts",
                        visible: false,
                        access_required: true,
                    },
                    {
                        title: "Сводный отчет",
                        name: "reports_main",
                        path: "/reports/main",
                        visible: false,
                        access_required: true,
                    },
                    {
                        title: "Планирование заготовок",
                        name: "reports_preparation",
                        path: "/reports/preparation",
                        visible: false,
                        access_required: true,
                    },
                    {
                        title: "Мотивация сотрудников",
                        name: "reports_motivation",
                        path: "/reports/motivation",
                        visible: false,
                        access_required: true,
                    },
                    {
                        title: "Отчет по дням",
                        name: "reports_by_days",
                        path: "/reports/by_days",
                        visible: false,
                        access_required: true,
                    },
                    {
                        title: "Отчет по принятию товаров",
                        name: "reports_product_orders",
                        path: "/reports/product_orders",
                        visible: false,
                        access_required: true,
                    },
                    {
                        title: "Отчёт по товарам",
                        name: "reports_by_products",
                        path: "/reports/by_products",
                        visible: false,
                        access_required: true,
                    },
                    {
                        title: "Отчёт по питанию сотрудников",
                        name: "reports_food_workers",
                        path: "/reports/food_workers",
                        visible: false,
                        access_required: true,
                    },
                    {
                        title: "Аналитика списаний",
                        name: "reports_write_off",
                        path: "/reports/write_off",
                        visible: false,
                        access_required: true,
                    },
                    {
                        title: "Отчет по бронированию",
                        name: "reports_reservation",
                        path: "/reports/reservation",
                        visible: false,
                        access_required: true,
                    },
                    {
                        title: "Отчет по часам",
                        name: "reports_by_hours",
                        path: "/reports/by_hours",
                        visible: false,
                        access_required: true,
                    },
                    {
                        title: "Стоп листы",
                        name: "reports_stop_lists",
                        path: "/reports/stop_lists",
                        visible: false,
                        access_required: true,
                    },
                    {
                        title: "Оборачиваемость столов",
                        name: "reports_table_updates",
                        path: "/reports/table_updates",
                        visible: false,
                        access_required: true,
                    },
                    {
                        title: "Наполняемость среднего чека",
                        name: "reports_filling_average_check",
                        path: "/reports/filling_average_check",
                        visible: false,
                        access_required: true,
                    },
                    {
                        title: "Неинтегрированные заказы",
                        name: "reports_non_integrated_orders",
                        path: "/reports/non_integrated_orders",
                        visible: false,
                        access_required: true,
                    },
                    {
                        title: "Отчет по подсказкам для заказов",
                        name: "reports_order_helpers",
                        path: "/reports/order_helpers",
                        visible: false,
                        access_required: true,
                    },
                    {
                        title: "Ожидание гостя",
                        name: "reports_guest_wait_time",
                        path: "/reports/guest_wait_time",
                        visible: false,
                        access_required: true,
                    },
                    {
                        title: "Отчёт совета",
                        name: "reports_council",
                        path: "/reports/council",
                        visible: false,
                        access_required: true,
                    },
                    {
                        title: "Отчёт приготовления блюд",
                        name: "reports_cooking",
                        path: "/reports/cooking",
                        visible: false,
                        access_required: true,
                    },
                    {
                        title: "Детальные чеки",
                        name: "reports_detailed_checks",
                        path: "/reports/detailed_checks",
                        visible: false,
                        access_required: true,
                    },
                    {
                        title: "Эффективность официантов",
                        name: "reports_waiter_efficiency",
                        path: "/reports/waiter_efficiency",
                        visible: false,
                        access_required: true,
                    },
                    {
                        title: "Отчет по ТОП блюдам",
                        name: "reports_top_products",
                        path: "/reports/top_products",
                        visible: false,
                        access_required: true,
                    },
                    {
                        title: "Отчет по вакансиям",
                        name: "reports_vacancies",
                        path: "/reports/vacancies",
                        visible: false,
                        access_required: true,
                    },
                    {
                        title: "Cводная расходная",
                        name: "reports_summary_invoices",
                        path: "/reports/summary_invoices",
                        visible: false,
                        access_required: true,
                    },
                    {
                        title: "Загруженность ресторанов",
                        name: "reports_workload",
                        path: "/reports/workload",
                        visible: false,
                        access_required: true,
                    },
                    {
                        title: "Отчет по инвестициям",
                        name: "reports_investments",
                        path: "/reports/investments",
                        visible: false,
                        access_required: true,
                    },
                    {
                        title: "Отчёт по среднему времени заказов на устройствах",
                        name: "reports_average_time_of_fronts",
                        path: "/reports/average_time_of_fronts",
                        visible: false,
                        access_required: true,
                    },
                    {
                        title: "Отчёт директорам",
                        name: "reports_tatar_report",
                        path: "/reports/tatar_report",
                        visible: false,
                        access_required: true,
                    },
                    {
                        title: "Отчёт по продажам",
                        name: "reports_plan_sales",
                        path: "/reports/plan_sales",
                        visible: false,
                        access_required: true,
                    },
                    {
                        title: "Отчёт по контрагентам",
                        name: "reports_counteragents",
                        path: "/reports/counteragents",
                        visible: false,
                        access_required: true,
                    },
                    {
                        title: "Отчёт для спринта",
                        name: "reports_sprint",
                        path: "/reports/sprint",
                        visible: false,
                        access_required: true,
                    },
                    {
                        title: "Оборотно-сальдовая ведомость",
                        name: "balance_sheet",
                        path: "/reports/balance_sheet",
                        visible: false,
                        access_required: true,
                    },
                ],
            },
            {
                title: "Развитие",
                name: "development",
                path: null,
                visible: false,
                active: false,
                dropdown: true,
                access_required: true,
                icon: "projects.svg",
                items: [
                    {
                        title: "Проекты",
                        name: "development_projects",
                        path: "/development/projects",
                        visible: false,
                        access_required: true,
                    },
                    {
                        title: "Сметы",
                        name: "development_estimates",
                        path: "/development/estimates",
                        visible: false,
                        access_required: true,
                    },
                ]
            },
            {
                title: "Корпоративные заказы",
                name: "corporate_orders_products",
                path: "/corporate_orders/products",
                visible: false,
                active: false,
                dropdown: false,
                access_required: false,
                icon: "corporateOrders.svg",
                items: null,
            },
            {
                title: "Каледнарь банкетов",
                name: "bankets",
                path: "/bankets/calendar",
                visible: false,
                active: false,
                dropdown: false,
                access_required: false,
                icon: "schedule.svg",
                items: null,
            },
            {
                title: "Обучение",
                name: "learning",
                path: "/learning",
                visible: false,
                active: false,
                dropdown: false,
                access_required: false,
                icon: "learning.svg",
                items: null,
            },
            {
                title: "Чеклисты",
                name: "checklists",
                visible: false,
                active: false,
                dropdown: true,
                access_required: true,
                icon: "learning.svg",
                items: [
                    {
                        title: "Внесение чек-листов",
                        name: "checklists",
                        path: "/checklists/entering",
                        visible: false,
                        access_required: true,
                    },
                    {
                        title: "Аналитика",
                        name: "checklists_analytics",
                        path: "/checklists/analytics",
                        visible: false,
                        access_required: true,
                    },
                    {
                        title: "Сводный отчет чек-листов",
                        name: "checklists_analytics",
                        path: "/checklists/report",
                        visible: false,
                        access_required: true,
                    }
                ],
            },
            {
                title: "Начисления",
                name: "profits",
                path: "/profits",
                visible: false,
                active: false,
                dropdown: false,
                access_required: true,
                icon: "profits.svg",
                items: null,
            },
            {
                title: "Отзывы",
                name: "feedback",
                path: null,
                visible: false,
                active: false,
                dropdown: true,
                access_required: true,
                icon: "feedback.svg",
                items: [
                    {
                        title: "Показатели НПС",
                        name: "feedback_nps",
                        path: "/feedback/nps",
                        visible: false,
                        access_required: true,
                    },
                    {
                        title: "Хештеги",
                        name: "feedback_hashtags",
                        path: "/feedback/hashtags",
                        visible: false,
                        access_required: true,
                    },
                    {
                        title: "Отзывы",
                        name: "feedback_all_reviews",
                        path: "/feedback/all_reviews",
                        visible: false,
                        access_required: true,
                    },
                    {
                        title: "Метрики Голос",
                        name: "feedback_golos_metrics",
                        path: "/feedback/golos_metrics",
                        visible: false,
                        access_required: true,
                    },
                    {
                        title: "Заполнение данных",
                        name: "feedback_feedback_edit",
                        path: "/feedback/feedback_edit",
                        visible: false,
                        access_required: true,
                    },
                ],
            },
            // {
            //     title: "Товары",
            //     name: "products",
            //     path: "/products",
            //     visible: false,
            //     active: false,
            //     dropdown: false,
            //     access_required: false,
            //     icon: "products.svg",
            //     items: null,
            // },
        ],
    },

    mutations: {
        setPointsOfSale(state, data) {
            if (data.length > 0) {
                state.points_of_sale = data;
                for (let i = 0; i < data.length; i++) {
                    state.points_of_sale[i].label = data[i].name;
                    state.points_of_sale[i].value = String(data[i].code);
                }
            }
        },

        setProfileData(state, data) {
            state.userData = data;
            (state.username = data.username), (state.first_name = data.first_name);
            state.user_permissions = data.permissions;
            state.tcoins = data.tcode_bonuses;
        },

        setMobileSidebar(state, bool) {
            state.mobileSidebar = bool;
        },

        setNotifications(state, data) {
            state.notifications = data
        },

        setGlobalLoading(state, bool) {
            state.isLoading = bool
        },

        setNewYearStatus(state, bool) {
            state.newYearStatus = bool
        }
    },

    getters: {
        getUserPermissions(state) {
            if(state.user_permissions) {
                return state.user_permissions
            }
        }
    },

    actions: {
        async getPointOfSale({ commit }) {
            try {
                const response = await apiClient.get(PROJECT_PREFIX.tcode + "/shops/", {
                    headers: {
                        Authorization: "Token " + localStorage.getItem("token"),
                    },
                });
                commit("setPointsOfSale", response.data);
                return response.data
            } catch (err) {
                alert(err);
            }
        },
        // setCurrentShop(state, data) {
        //     state.current_shop = data
        //     console.log(state.current_shop)
        // },
        getProfileData({ commit, dispatch }, token) {
            const authToken = token ? token : localStorage.getItem("token")

            // Show cached data immediately, then refresh permissions from the server.
            const cached = getCachedProfile()
            if (cached) {
                commit("setProfileData", cached);
                dispatch("sidebarInit");
            }

            return apiClient.get(PROJECT_PREFIX.tcode + "/profile/", {
                    headers: {
                        Authorization: "Token " + authToken,
                    },
                })
                .then((response) => {
                    cacheProfile(response.data);
                    commit("setProfileData", response.data);
                    dispatch("sidebarInit");
                })
                .catch((error) => {
                    console.log(error);
                });
        },

        sidebarInit({ state }) {
            const general = ["home", "learning"];

            const hasAccess = (value, permissions) => {
                if (!value) return false;

                if (Array.isArray(value)) {
                    return value.some(v => permissions.includes(v));
                }

                return permissions.includes(value);
            };

            for (let i = 0; i < state.sidebarItems.length; i++) {
                const item = state.sidebarItems[i];

                // general
                if (general.includes(item.name)) {
                    item.visible = true;
                }

                // проверка по name И group
                if (hasAccess(item.name, state.user_permissions) || hasAccess(item.group, state.user_permissions)) {
                    item.visible = true;
                }

                if (item.dropdown) {
                    for (let link = 0; link < item.items.length; link++) {
                        const subItem = item.items[link];
                        if (subItem.name === 'assortment') {
                            subItem.visible = hasAccess('assortment_view', state.user_permissions || []);
                        }

                        if (
                            hasAccess(subItem.name, state.user_permissions) ||
                            hasAccess(subItem.group, state.user_permissions)
                        ) {
                            item.visible = true;
                            subItem.visible = true;
                        }
                    }
                }
            }
        },

        dropdownController({ state }, item) {
            for (let i = 0; i < state.sidebarItems.length; i++) {
                if (state.sidebarItems[i].name === item) {
                    if (state.sidebarItems[i].active) {
                        state.sidebarItems[i].active = false;
                    } else {
                        state.sidebarItems[i].active = true;
                    }
                } else {
                    state.sidebarItems[i].active = false;
                }
            }
        },

        mobileSidebarController({ state, commit }) {
            if (state.mobileSidebar) {
                commit("setMobileSidebar", false);
            } else {
                commit("setMobileSidebar", true);
            }
        },
    },
});
